import {
  deselectGifteeBoxTemplate,
  selectGifteeBoxTemplate
} from '@console/actions/actions';
import type {
  AppThunkAction,
  AppThunkDispatch
} from '@console/actions/thunkType';
import { requestBulkDeliverableUrlThunk } from '@console/actions/thunks/requestBulkDeliverableUrl';
import Table from '@console/components/project/delivery/Table';
import type { LocalGifteeBoxConfig } from '@console/reducers/projects';
import { connect } from 'react-redux';

const requestBulkDeliverableUrl =
  (urlCode: string, downloadType: string): AppThunkAction<void> =>
  dispatch => {
    dispatch(requestBulkDeliverableUrlThunk(urlCode, downloadType))
      .then(downloadUrl => {
        if (downloadUrl) {
          location.href = downloadUrl;
        }
      })
      .catch(() => {});
  };

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  requestBulkDeliverableUrl: (urlCode: string, downloadType: string) =>
    dispatch(requestBulkDeliverableUrl(urlCode, downloadType)),
  selectGifteeBoxTemplate: (
    gifteeBoxTemplate: LocalGifteeBoxConfig['gifteeBoxTemplate']
  ) => dispatch(selectGifteeBoxTemplate(gifteeBoxTemplate)),
  deselectGifteeBoxTemplate: () => dispatch(deselectGifteeBoxTemplate())
});

export type TablePropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type TablePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(Table);
